var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { WrapperStyled, LabelStyled, CenterContentStyled, CircleLoadingStyled, ColoredExtraBackgroundStyled, LoadingGraphStyled, ContentImage, ContentBackground, BorderContentBackground, } from './styled';
const CircularProgress = (_a) => {
    var props = __rest(_a, []);
    const { value, size, photoSrc, loadingMode: loadingProp, onClick, circleSize } = props, rest = __rest(props, ["value", "size", "photoSrc", "loadingMode", "onClick", "circleSize"]);
    const [loading, setLoading] = useState(loadingProp);
    useEffect(() => {
        setLoading(loadingProp);
    }, [loadingProp]);
    const handleClick = (event) => {
        onClick(event);
    };
    return (_jsxs(WrapperStyled, Object.assign({ "data-testid": "circularProgressWrapper", size: size, onClick: handleClick }, { children: [_jsx(LabelStyled, { children: _jsx("p", { children: `${value}%` }) }), _jsx(CircleLoadingStyled, Object.assign({}, rest, { size: size, value: value, circleSize: circleSize, loadingMode: loading })), _jsx(ColoredExtraBackgroundStyled, { loadingMode: loading }), _jsx(LoadingGraphStyled, Object.assign({ "data-testid": "circularProgressBar" }, rest, { value: value, loadingMode: loading })), _jsxs(CenterContentStyled, { children: [_jsx(BorderContentBackground, { children: _jsx(ContentBackground, { loadingMode: loading }) }), _jsx(ContentImage, { photoSrc: photoSrc })] })] })));
};
CircularProgress.defaultProps = {
    CircularProgress: false,
    value: 0,
};
export default CircularProgress;
//# sourceMappingURL=index.js.map